import PageContent from 'app/components/presentation/containers/page/PageContent';
import React, { ReactNode } from 'react';

const AuthPageContent = ({ children }: { children: ReactNode }) => (
  <PageContent maxWidth="396px">
    {children}
  </PageContent>
);

export default AuthPageContent;
